import { useQuery } from '@tanstack/react-query';
import { savApi } from '@/features/savs/api/savApi';
import type { SavListFilters } from '@/features/savs/types/sav.types';

export const useSavList = (filters?: SavListFilters) => {
  return useQuery({
    queryKey: ['sav-list', filters],
    queryFn: () => savApi.list(filters),
    refetchInterval: 30_000,
  });
};
